module.exports = "/static/assets/86c8f63128ac36ec23acc15f757267a8.png";